var map = {
	"./01-ubuntu.mdx": 795,
	"./02-debian.mdx": 796,
	"./03-redhat-or-centos.mdx": 797,
	"./04-freebsd.mdx": 798,
	"./05-docker.mdx": 799,
	"./06-macos.mdx": 800,
	"./07-windows.mdx": 801,
	"./08-linux.mdx": 802,
	"./09-aws.mdx": 803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;